import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import * as Sentry from '@sentry/angular';
import { environment } from './environments';

const { browserTracingIntegration, init: sentryInit, replayIntegration } = Sentry;

window.APP_VERSION = APP_VERSION;

// TODO: SentryIO: Disabled temporarily for SIT setup
// sentryInit({
//     dsn: 'https://9b75f9e34c1017a0c77b401027b44ff8@o4504140534906880.ingest.us.sentry.io/4508917011185664',
//     environment: environment.appEnv,
//     // ignoreErrors: []
//     tracesSampleRate: environment.production ? 0.1 : 1,
//     replaysSessionSampleRate: environment.production ? 0.1 : 1,
//     replaysOnErrorSampleRate: 1,
//     integrations: [browserTracingIntegration(), replayIntegration({ maskAllText: false, blockAllMedia: true })],
//     tracePropagationTargets: [/^\/api/],
//     release: APP_VERSION,
// });

bootstrapApplication(AppComponent, appConfig).catch(err => console.error(err));
